import React, { useImperativeHandle, useState, forwardRef } from 'react';
import { Button } from '../Elements';
import Modal from '../Modal';
import { ApiResponseType } from '../../../common/api/apiHelper';

interface CustomerErpTransfer {
    statusModalVisible: boolean;
    setStatusModalVisible: (visible: boolean) => void;
}

export interface CustomerErpTransferHandles {
    getResult: (erpCustomerTransferResults: any) => void;
}

const CustomerErpTransferModal = forwardRef<CustomerErpTransferHandles, CustomerErpTransfer>(
    ({ statusModalVisible, setStatusModalVisible }, ref) => {
        const [integrationResult, setIntegrationResult] = useState<ApiResponseType>({
            isSuccess: false,
            data: null,
            errorMessage: ""
        });

        useImperativeHandle(ref, () => ({
            getResult(erpCustomerTransferResults: ApiResponseType) {
                setIntegrationResult(erpCustomerTransferResults);
            }
        }));

        const getMessage = () => {
            if (integrationResult.isSuccess && !integrationResult.data?.erpParameterEmpty) {
                const { totalSend, successSend, existCustomer } = integrationResult.data;
                return (
                    <div className='m-1 p-1 max-w-[auto] flex-row items-center'>
                        {[
                            { label: "Toplam Aktarım", value: totalSend },
                            { label: "Başarılı Aktarım", value: successSend },
                            { label: "Mevcut Müşteri", value: existCustomer }
                        ].map(({ label, value }, index) => (
                            <div key={index} className='my-1 py-1 flex flex-row'>
                                <h3 className='basis-5/12 font-bold text-black-50 text-sm text-right min-w-[164px]'>{label}:</h3>
                                <div className="basis-7/12 text-sm text-left pl-2 max-w-[90px]">{value}</div>
                            </div>
                        ))}
                    </div>
                );
            } else if (integrationResult.isSuccess && integrationResult.data?.erpParameterEmpty) {
                return (
                    <div className='flex flex-col items-center justify-center w-[auto]'>
                        <div className='flex pb-2'>
                            <h3 className='flex items-center justify-end min-w-[77px]'>Hata Mesajı: </h3>
                            <div className="flex justify-start text-left pl-2 min-w-[184px]">Erp parmetresini doldurunuz.</div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className='flex flex-col items-center justify-center w-[auto]'>
                        <div className='flex pb-2'>
                            <h3 className='flex items-center justify-end min-w-[77px]'>Hata Mesajı: </h3>
                            <div className="flex justify-start text-left pl-2 min-w-[175px]">{integrationResult.errorMessage}</div>
                        </div>
                    </div>
                );
            }
        };

        const getStatusImageUrl = () => (
            integrationResult.isSuccess && !integrationResult.data?.erpParameterEmpty
                ? "/icons/basarili.svg"
                : "/icons/basarisiz.svg"
        );

        const handleClose = () => {
            setStatusModalVisible(false);
        };

        return (
            <Modal openModal={statusModalVisible} setOpenModal={setStatusModalVisible}>
                <div>
                    <div className="sm:flex sm:items-start">
                        <div className="flex flex-col items-center mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 className="text-lg leading-6 font-large text-gray-900">Bilgilendirme Mesajı</h3>
                            <div className="flex flex-row justify-between w-[320px] mt-4">
                                <div className='flex items-center'>
                                    <div className="flex w-[auto] h-max items-center">
                                        <img
                                            className="flex text-success h-10 w-10"
                                            src={getStatusImageUrl()}
                                            alt="status"
                                        />
                                    </div>
                                </div>
                                <div className="xl:basis-1/3 lg:basis-1/2 md:basis-1/2 sm:basis-1/2 m-1 p-1">
                                    {getMessage()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-1 sm:mt-4 flex justify-end space-x-2">
                        <Button color="gray" hover="gray" size="xs" callback={handleClose}>
                            Kapat
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }
);

export default CustomerErpTransferModal;
